<div [ngClass]="getClassNames()">
  <div class="ub-box__title">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="ub-box__content">
    <ng-content select="[content]"></ng-content>
  </div>
  <div class="ub-box__footer">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
